import React from 'react';
import './cardFaqView.module.scss';
import { FaqIndexView } from '../../../types/faqs';

type Props = {
    faq: FaqIndexView;
};

export class CardFaqView extends React.Component<Props> {
    render() {
        const { faq } = this.props;
        return (
            <div id={faq.id.toString()} styleName="question-contents-wrapper">
                <p styleName="question-title">Q. {faq.question}</p>
                <div styleName="question-answer">
                    <div dangerouslySetInnerHTML={{ __html: 'A. ' + faq.answer }} />
                </div>
                {faq.link && (
                    <p styleName="question-link">
                        <a href={faq.link}>>> 関連ページへのリンク</a>
                    </p>
                )}
            </div>
        );
    }
}
